import React from 'react';

import Layout from '@/components/Layout';

import { Text, Flex, Box, Container } from 'theme-ui';
import Halo from '@/components/Halo';
// import { graphql } from 'gatsby';
import { WorkCard } from './about';
// import { ServicesList } from './services';

export interface HomeProps {
  data: any;
}

// const Home: React.FC<HomeProps> = ({ data }) => {

function Home({ data }: HomeProps) {
  const postEdges = (data && data.caseStudies && data.caseStudies.edges) || [];
  return (
    <Layout>
      <Halo
        title="Works"
        description="kind of works we do"
        author=""
        image=""
        url=""
      />
      <Box variant="styles.pageFrame">
        <Container sx={{ pb: 6 }}>
          <Box>
            <Text as="h1" variant="pageTitle">
              Case Studies
            </Text>
            <Text as="p" variant="pageDesc">
              Insight into how we solve problems
            </Text>
          </Box>
        </Container>

        <Container>
          <Flex sx={{ flexDirection: [`column`, `row`, `row`] }}>
            <Box
              sx={{
                width: [`100%`, `100%`, `20%`],
                display: [`none`, `flex`, `flex`],
              }}
            >
              {/* <Box as="ul" sx={{ pl: 0, mr: 3 }}>
                {ServicesList.map((post: any) => (
                  <Box
                    as="li"
                    sx={{
                      listStyle: `none`,
                      borderBottom: `solid 1px`,
                      borderBottomColor: `grays.4`,
                      pl: 0,
                      ml: 0,
                      fontSize: 2,
                      fontWeight: 500,
                      mb: 2,
                    }}
                  >
                    {post?.title}
                  </Box>
                ))}
              </Box> */}
            </Box>
            <Box sx={{ width: [`100%`, `100%`, `80%`] }}>
              {postEdges && (
                <Flex
                  sx={{
                    flexWrap: [`wrap`, `wrap`],
                    flexDirection: [`column`, `row`, `row`],
                  }}
                >
                  {postEdges.map((post: any) => (
                    <WorkCard post={post} />
                  ))}
                </Flex>
              )}
            </Box>
          </Flex>
        </Container>
      </Box>
    </Layout>
  );
}

export default Home;

// export const query = graphql`
//   query CaseStudiesPageQuery {
//     caseStudies: allSanityCaseStudy(
//       filter: { slug: { current: { ne: null } } }
//     ) {
//       edges {
//         node {
//           id
//           title
//           mainImage {
//             asset {
//               gatsbyImageData(
//                 fit: FILLMAX
//                 placeholder: BLURRED
//                 width: 600
//                 height: 400
//               )
//             }
//           }
//           slug {
//             current
//           }
//         }
//       }
//     }
//   }
// `;
